module.exports = require("./sr-Cyrl.d.ts");